export function normalizeAssistantSuggestions(value) {
  if (!Array.isArray(value)) return [];

  return value
    .map((item) => {
      if (typeof item === 'string' && item.trim()) {
        return {
          label: item.trim(),
          href: null,
        };
      }

      if (item && typeof item === 'object') {
        const label = typeof item.label === 'string' ? item.label.trim() : '';
        const href = typeof item.href === 'string' && item.href.trim().startsWith('/') ? item.href.trim() : null;
        if (label) {
          return { label, href };
        }
      }

      return null;
    })
    .filter(Boolean);
}

export function getAssistantErrorMessage(error) {
  const status = error?.response?.status;
  const responseMessage =
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error?.response?.data?.details;

  if (typeof responseMessage === 'string' && responseMessage.trim() && status !== 404) {
    return responseMessage.trim();
  }

  if (status === 401) {
    return 'Please sign in again to use the assistant.';
  }

  if (status === 404) {
    return 'The platform assistant is not available in this environment yet.';
  }

  return 'The platform assistant is unavailable right now. Please try again shortly.';
}
